// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"de1b174c","455":"3b4c085c","584":"1e93963e","977":"178c0834"}[chunkId] + ".chunk.js";
};